module.exports = {
  ...require('./consts'),
  ...require('./data'),
};
